import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

// Progressive-enhancement reveal: content is in the DOM and readable without JS animation.
export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const reduce = useReducedMotion();
  const Tag = motion[as];
  if (reduce) return <Tag className={className}>{children}</Tag>;
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-12% 0px" }}
      transition={{ duration: 0.7, ease: EASE, delay }}
    >
      {children}
    </Tag>
  );
};

export const ChapterLabel = ({ index, label, testid }) => (
  <div data-testid={testid} className="flex items-center gap-4">
    <span className="font-mono text-[12px] tracking-[0.3em] text-gold">{String(index).padStart(2, "0")}</span>
    <span className="w-10 h-px bg-gold/50" />
    <span className="text-[12px] tracking-[0.3em] uppercase text-zinc-300">{label}</span>
  </div>
);

// Responsive local still with an honest provenance tag ("Markenfilm", "Symbolbild", "Echte Kundenarbeit").
export const StoryImage = ({ name, widths = [640, 1280, 1920], alt, tag, sizes = "(min-width: 1024px) 55vw, 100vw", className = "", testid }) => (
  <figure data-testid={testid} className={`relative overflow-hidden bg-[#0A0A0C] ${className}`}>
    <img
      src={`/img/story/${name}-${widths[1] || widths[0]}.webp`}
      srcSet={widths.map((w) => `/img/story/${name}-${w}.webp ${w}w`).join(", ")}
      sizes={sizes}
      alt={alt}
      width="1920"
      height="1080"
      loading="lazy"
      decoding="async"
      className="w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.02]"
    />
    {tag && (
      <figcaption className="absolute left-4 bottom-4 text-[11px] tracking-[0.22em] uppercase text-white/80 bg-black/55 backdrop-blur-sm px-2.5 py-1">
        {tag}
      </figcaption>
    )}
  </figure>
);
